import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findDrivingLicenseClasses = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/drivingLicenseClass${query}`, {
        headers,
    });
};

export const findDrivingLicenseClassById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/drivingLicenseClass/${id}`, {
        headers,
    });
};
